import { Component, OnInit, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { LayoutService } from '../../core/layout.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements OnInit {
  @ViewChild('kt_account_menu', { static: false, read: ElementRef })
  public ktAccountMenu: ElementRef;

  public toolbarButtonMarginClass = 'ms-1 ms-lg-3';
  public headerLeft: string = 'menu';

  constructor(
    private layout: LayoutService,
  ) {}

  public ngOnInit(): void {
    this.headerLeft = this.layout.getProp('header.left') as string;
  }
}
